import * as MOTOR_CREDIT_CORE from '../constants/MotorcreditConstants';
import * as GlobalConstants from '../constants/GlobalConstants';
import {COMMON} from '../../common/constants/LabelConstants';
import {PERSONAL_DATA_PATH} from '../constants/RoutesConstant';
import {GLOBAL} from '../../pay-warranty/constants/LabelConstants';

export const mapStateToStepApplicantData = state => ({
    personal: {
        firstName: state.creditoReal.loanApplication.applicantPersonal.firstName,
        secondName: state.creditoReal.loanApplication.applicantPersonal.secondName,
        lastName: state.creditoReal.loanApplication.applicantPersonal.lastName,
        secondLastName: state.creditoReal.loanApplication.applicantPersonal.secondLastName,
        birthDate: state.creditoReal.loanApplication.applicantPersonal.birthDate,
        docNumber: state.creditoReal.loanApplication.applicantPersonal.docNumber,
        cellPhone: state.creditoReal.loanApplication.applicantPersonal.cellPhone,
        email: state.creditoReal.loanApplication.applicantPersonal.email,
        gender: state.creditoReal.loanApplication.applicantPersonal.gender,
        civilStatus: state.creditoReal.loanApplication.applicantPersonal.civilStatus,
        studiesLevel: state.creditoReal.loanApplication.applicantPersonal.studiesLevel,
        economicDependents: parseInt(state.creditoReal.loanApplication.applicantPersonal.economicDependents.id, 10),
        alreadyHasVehicle: state.creditoReal.loanApplication.applicantPersonal.alreadyHasVehicle.value,
        nationality: state.creditoReal.loanApplication.applicantPersonal.nationality,
    },
    calculator: {
        includeInsurance: state.creditoReal.calculator.hasInsurance,
        term: parseInt(state.creditoReal.calculator.monthlyPayment.id, 10),
        downPayment: parseFloat(state.creditoReal.calculator.downPayment),
        postalCode: state.creditoReal.calculator.postalCode,
        cveClick: state.creditoReal.calculator.versionSelected.payload,
        state: state.creditoReal.calculator.provinceSelected,
        assemblyCountry: state.creditoReal.calculator.assemblyCountrySelected,
        desiredVehicle: {
            brand: state.creditoReal.calculator.brandSelected,
            model: state.creditoReal.calculator.modelSelected,
            version: state.creditoReal.calculator.versionSelected,
            year: parseInt(state.creditoReal.calculator.yearSelected.value, 10),
            price: parseFloat(state.creditoReal.calculator.price),
        }
    },
    bureauSkipped: false,
    extraData: getExtraData(1, state)
});

export const mapStateToHubspotData = (state) => {
    const email = state.creditoReal.loanApplication.applicantPersonal.email;
    const firstName = state.creditoReal.loanApplication.applicantPersonal.firstName;
    const secondName = state.creditoReal.loanApplication.applicantPersonal.secondName;
    const completeFirstName = `${firstName}${secondName ? ` ${secondName}` : ''}`;
    const lastName = state.creditoReal.loanApplication.applicantPersonal.lastName;
    const secondLastName = state.creditoReal.loanApplication.applicantPersonal.secondLastName;
    const completeLastName = `${lastName}${secondLastName ? ` ${secondLastName}` : ''}`;
    const pageUrl = `${document.location.protocol}//${document.location.host}/${PERSONAL_DATA_PATH}`;
    return {
        fields: [{
            email,
            firstname: completeFirstName,
            lastname: completeLastName
        }],
        context: {
            pageUri: pageUrl,
            pageName: COMMON.MOTORFY_LABEL
        }
    };
};

export const mapStateToStepTurboCash = (state, action) => ({
    quoteAccepted: action.quoteAccepted,
    offer: action.msgOffer,
    offerAccepted: action.offerAccepted,
    downPayment: parseFloat(state.creditoReal.calculator.downPayment),
    term: parseInt(state.creditoReal.calculator.monthlyPayment.id, 10),
    includeInsurance: state.creditoReal.calculator.hasInsurance
});

export const mapStateToProfileSimulator = (state, action) => ({
    term: parseInt(state.creditoReal.calculator.monthlyPayment.id, 10),
    downPayment: parseFloat(state.creditoReal.calculator.downPayment),
    hasInsurance: state.creditoReal.calculator.hasInsurance,
    accept: action.quoteAccepted ? GLOBAL.ACCEPTED_QUOTE : GLOBAL.NON_ACCEPTED_QUOTE,
    includeMechanicalWarranty: false
});

export const mapStateToTurboCash = (state) => {
    const {
        turboCash: {
            loanApplication: {
                applicantPersonal,
                applicantEmployment,
                otherReferences
            }
        },
    } = state;
    return {
        home: {
            holdTime: parseInt(applicantPersonal.houseHoldTime.value, 10),
            holdTimeMeasure: applicantPersonal.houseHoldMeasure.value || GlobalConstants.EMPTY_STRING,
            houseType: applicantPersonal.houseType
        },
        personal: {
            civilStatus: applicantPersonal.civilStatus,
            regime: applicantPersonal.regime,
            roleAtHome: applicantPersonal.rolHome,
            studiesLevel: applicantPersonal.studies,
            economicDependents: applicantPersonal.amountDependents ?
                parseInt(applicantPersonal.amountDependents, 10) : 0,
            curp: applicantPersonal.cURP
        },
        employment: {
            employmentBusinessType: applicantEmployment.employmentRotation,
            workplaceName: applicantEmployment.workplaceName,
            position: applicantEmployment.position,
            workingSince: applicantEmployment.workingSince,
            address: applicantEmployment.address,
            extNumber: applicantEmployment.extNumber,
            intNumber: applicantEmployment.intNumber,
            streetBetween: applicantEmployment.streetBetween,
            workplacePhone: applicantEmployment.workplacePhone,
            workplacePhoneExt: applicantEmployment.workplacePhoneExt,
            monthlyIncomes: parseInt(applicantEmployment.monthlyIncomes, 10),
            postalCode: applicantEmployment.postalCode,
            state: applicantEmployment.state,
            city: applicantEmployment.city,
            municipality: applicantEmployment.municipality,
            colony: applicantEmployment.selectedColony
        },
        references: otherReferences.references.map(reference => ({
            completeName: reference.completeName,
            phone: reference.cellphone,
            landLinePhone: reference.phone,
            home: {
                address: reference.address,
                extNumber: reference.extNumber,
                intNumber: reference.intNumber,
                postalCode: reference.postalCode,
                state: reference.state || GlobalConstants.EMPTY_CATALOG,
                city: reference.city || GlobalConstants.EMPTY_CATALOG,
                municipality: reference.municipality || GlobalConstants.EMPTY_CATALOG,
                colony: reference.selectedColony || GlobalConstants.EMPTY_CATALOG
            }
        }))
    };
};

export const mapStateToStepValidateIdentityNIP = state => ({
    nipCode: state.creditoReal.loanApplication.nip.identityBureau,
    extraData: getExtraDataSimple(4, state)
});

export const mapStateToStepApplicantDomicile = (state) => {
    const {applicantHome} = state.creditoReal.loanApplication;
    return {
        home: {
            address: applicantHome.address,
            extNumber: applicantHome.extNumber,
            intNumber: applicantHome.intNumber,
            postalCode: applicantHome.postalCode,
            state: applicantHome.state,
            city: (applicantHome.city &&
                applicantHome.city.id !== '' &&
                applicantHome.city.id !== null) ? {
                    id:  applicantHome.city.id,
                    value:  applicantHome.city.value,
                } : null,
            municipality: applicantHome.municipality,
            colony: applicantHome.selectedColony,
            phone: applicantHome.phone,
            houseHold: {
                number: applicantHome.houseHoldTime.value ?
                    parseInt(applicantHome.houseHoldTime.value, 10) :
                    null,
                lapse: applicantHome.houseHoldMeasure.value || GlobalConstants.EMPTY_STRING,
            },
            houseType: applicantHome.houseType
        },
        extraData: getExtraDataSimple(3, state)
    };
};

export const mapStateToStepValidateBureauNIP = state => ({
    nipCode: state.creditoReal.loanApplication.nip.identityBureau,
    extraData: getExtraDataSimple(4, state)
});

export const mapStateToStepValidateBureauScotiaNIP = state => ({
    nipCode: state.scotiaBank.loanApplication.nip.identityBureau,
    extraData: getExtraDataSimple(4, state)
});

export const mapStateToStepCreditHistory = state => ({
    bureau: {
        bureauOption: state.creditoReal.loanApplication.creditHistory.bureauOption.filter(
            i => i.payload).map(i => ({id: i.id, value: i.value})),
        bureauOptionCreditCardLastDigits:
        state.creditoReal.loanApplication.creditHistory.bureauOptionCreditCardLastDigits
    },
    extraData: getExtraDataSimple(4, state)
});

export const mapStateToStepApplicantEmployment = (state) => {
    const employmentData = state.creditoReal.loanApplication.applicantEmployment;
    const catalogs = state.catalogs;
    const monthlyIncomes = parseFloat(employmentData.includeMonthlyIncomes ? employmentData.monthlyIncomes : 0);

    return {
        employmentData: {
            monthlyIncomes,
            workplaceName: employmentData.workplaceName,
            position: employmentData.position,
            workingSince: employmentData.workingSince,
            address: employmentData.address,
            extNumber: employmentData.extNumber,
            intNumber: employmentData.intNumber,
            postalCode: employmentData.postalCode,
            state: employmentData.state,
            city: (employmentData.city &&
                employmentData.city.id !== '' &&
                employmentData.city.id !== null) ? {
                    id: employmentData.city.id,
                    value: employmentData.city.value,
                } : null,
            municipality: employmentData.municipality,
            colony: employmentData.selectedColony,
            workplacePhone: employmentData.workplacePhone,
            workplacePhoneExt: employmentData.workplacePhoneExt,
            employmentRelationshipId: employmentData.employmentRelationshipTypeId,
            documentType: monthlyIncomes === 0 ?
                catalogs.crDocumentType.find(x => x.id === '0') : employmentData.documentType,
            businessType: employmentData.employmentRelationshipTypeId !== MOTOR_CREDIT_CORE.CR_DEPENDENT_CATALOG_ID ?
                employmentData.businessType : undefined,
        },
        extraData: getExtraDataSimple(5, state)
    };
};

export const mapStateToStepApplicantEmploymentPartials = (state) => {
    const employmentData = state.creditoReal.loanApplication.applicantEmployment;
    const catalogs = state.catalogs;
    const monthlyIncomes = parseFloat(employmentData.includeMonthlyIncomes ? employmentData.monthlyIncomes : 0);

    return {
        partialEmploymentData: {
            monthlyIncomes,
            employmentRelationshipId: employmentData.employmentRelationshipTypeId,
            documentType: monthlyIncomes === 0 ?
                catalogs.crDocumentType.find(x => x.id === '0') : employmentData.documentType,
            businessType: employmentData.employmentRelationshipTypeId !== MOTOR_CREDIT_CORE.CR_DEPENDENT_CATALOG_ID ?
                employmentData.businessType : undefined,
            workingSince: employmentData.workingSince,
            invoiceInfo: {
                billingTypeId: employmentData.billingTypeId,
                ...(employmentData.billingTypeId === 'TAX' && {
                    taxRegimeId: employmentData.taxRegimeId,
                    billingDocumentId: state.creditoReal.loanApplication.files.work?.billingFiles?.[0]?.id,
                }),
            },
        }
    };
};

export const mapStateToStepOtherReferences = state => ({
    otherReferences: state.creditoReal.loanApplication.otherReferences.map(item => ({
        completeName: `${item.firstName} ${item.lastName} ${item.secondLastName}`,
        firstName: item.firstName,
        lastName: item.lastName,
        secondLastName: item.secondLastName,
        phone: item.phone})),
    extraData: getExtraDataSimple(6, state)
});

export const mapStateToStepInsurance = state => {
    const hasInsuranceSelected = state.creditoReal.loanApplication.insurance.insuranceSelected &&
        state.creditoReal.loanApplication.insurance.insuranceSelected.target;
    return {
        insurance: {
            includeInsurance: hasInsuranceSelected ? state.creditoReal.loanApplication.insurance.includeInsurance : false,
            insuranceSelected: state.creditoReal.loanApplication.insurance.insuranceSelected.target ?
                state.creditoReal.loanApplication.insurance.insuranceSelected : null,
            failInsurance: state.creditoReal.loanApplication.insurance.failInsurance,
        },
        extraData: getExtraDataSimple(7, state)
    }
};

export const mapStateToStepMarketingSource = state => ({
    marketingSource: state.creditoReal.loanApplication.marketingSource,
    extraData: getExtraDataSimple(8, state)
});

function getExtraData(step, state) {
    const newStep = step < state.creditoReal.loanApplication.highestStep ?
        state.creditoReal.loanApplication.highestStep : step;
    return {
        step: newStep,
        ip: state.location.ip,
        location: state.location.geo,
        pointOfSaleType: MOTOR_CREDIT_CORE.POINT_OF_SALE_TYPE,
        pointOfSaleUserId: state.profile.userId,
        pointOfSaleUserEmail: state.profile.email,
        pointOfSaleUserName: `${state.profile.firstName} ${state.profile.lastName}`,
        pointOfSaleUserRoles: state.profile.roles,
        firstReferer: state.utmData.firstReferer,
        utmData: {
            utmSource: state.utmData.utmSource,
            utmMedium: state.utmData.utmMedium,
            utmCampaign: state.utmData.utmCampaign,
            utmTerm: state.utmData.utmTerm,
            utmContent: state.utmData.utmContent,
            utmUrl: state.utmData.aUtmUrl,
            gclid: state.utmData.gclid,
            aHttpReferer: state.utmData.aHttpRefer,
            userAgent: state.utmData.userAgent
        },
        deviceData: {
            deviceType: state.utmData.typeDevice,
            operatingSystem: state.utmData.operatingSystem,
            resolutionWidth: state.utmData.resolutionWidth,
            resolutionHeight: state.utmData.resolutionHeight
        },
        vehicleId: state.catalogs.queryStringIdVehicle,
        metaData: {
            group: {
                [state.catalogs.queryStringGroupName]: state.catalogs.queryStringGroupId
            },
            vehiclePremiumInfo: state.catalogs.isUrlFromPI ?
                {
                    dealerId: state.catalogs.queryStringGroupId,
                    dealerName: state.catalogs.queryStringGroupName,
                    city: state.catalogs.queryStringGroupLocation,
                    vehicleId: state.catalogs.queryStringIdVehicle,
                    originalPhoto: state.catalogs.queryStringOriginalPhoto,
                    thumbnailPhoto: state.catalogs.queryStringThumbnailPhoto
                } : {}
        }
    };
}

export const getExtraDataSimple = (step, state) => ({
    step: step < state.creditoReal.loanApplication.highestStep ? state.creditoReal.loanApplication.highestStep : step
});

export const mapUpdateReportValidationIdStateToApi = (state, action) => {
    const loanApplicationState = state.creditoReal.loanApplication;
    const loanApplicationToken = loanApplicationState.token;
    return ({
        loanApplicationToken,
        curp: action.curp,
        token: action.token
    });
};

export const mapValidateIDStateToApi = (state, action) => {
    const loanApplicationState = state.creditoReal.loanApplication;
    const loanApplicationToken = loanApplicationState.token;
    const files = loanApplicationState.files;
    const ifeFrontFile = files.identification.ifeFrontFiles[0];
    const ifeBackFile = files.identification.ifeBackFiles[0];
    return ({
        loanApplicationToken,
        firstName: loanApplicationState.applicantPersonal.firstName,
        secondName: loanApplicationState.applicantPersonal.secondName,
        lastName: loanApplicationState.applicantPersonal.lastName,
        secondLastName: loanApplicationState.applicantPersonal.secondLastName,
        documentNumber: loanApplicationState.applicantPersonal.docNumber,
        birthDate: loanApplicationState.applicantPersonal.birthDate.replace(/-/g, '/'),
        homeAddress: loanApplicationState.applicantHome.address,
        homeNumExt: loanApplicationState.applicantHome.extNumber,
        homeNumInt: loanApplicationState.applicantHome.intNumber,
        homePostalCode: loanApplicationState.applicantHome.postalCode,
        homeColony: loanApplicationState.applicantHome.selectedColony.value,
        workOccupation: loanApplicationState.applicantEmployment.position,
        frontIdFile: {
            originalUrl: ifeFrontFile.originalUrl,
            thumbnailUrl: ifeFrontFile.thumbnailUrl,
            type: ifeFrontFile.mimeType,
            name: ifeFrontFile.fileName
        },
        backIdFile: {
            originalUrl: ifeBackFile.originalUrl,
            thumbnailUrl: ifeBackFile.thumbnailUrl,
            type: ifeBackFile.mimeType,
            name: ifeBackFile.fileName
        }
    });
};
